/* Cotizador */
const MONEY_REGEX = /\B(?=(\d{3})+(?!\d))/g;

const total_precio_input                          = document.querySelector("input[name='total-precio']");
const total_precio_html                           = document.querySelector(".precio");
// Buttons
const button_submit                               = document.querySelector(".botones .agregar");
const button_reset                                = document.querySelector(".botones .volver");
// Acordeon
const cotiza_titles                               = document.querySelectorAll(".title-select-h1");
const cotiza_subtitles                            = document.querySelectorAll(".title-select-h4");
const cotiza_options                              = document.querySelectorAll(".option");
const label_radios                                = document.querySelectorAll(".label-colores");
const region_select                               = document.querySelector(".region-select");
const region_comuna                               = document.querySelector(".region-comuna");
const region_direccion                            = document.querySelector(".region-direccion");
const radio_container                             = document.querySelector(".radio-container");
const radio_message_container                     = document.querySelector(".radio-message-container");
const address_container                           = document.querySelector(".address-container");
const comunas_select                              = document.querySelector(".region-comunas");
const preview_image                               = document.querySelector(".inner-image");
const preview_image_zoom                          = document.querySelector(".inner-image-zoom");
// Formulario
const input_cortina_tipos                         = document.querySelectorAll("input[name='cortina-tipos']");
const input_sucursal                              = document.querySelector("select[name='sucursal']");
const input_ancho                                 = document.querySelector("input[name='ancho']");
const input_alto                                  = document.querySelector("input[name='alto']");
const input_tela_tipos                            = document.querySelectorAll("input[name='tela-tipos']");
const input_tela_suboptions                       = document.querySelectorAll("input[name='tela-suboptions']");
const input_tela_opcion_colores                   = document.querySelectorAll("input[name='tela-opcion-colores']");
const input_accionamiento_tipos                   = document.querySelectorAll("input[name='accionamiento-tipos']");
const input_caida_sentidos                        = document.querySelectorAll("input[name='caida-sentidos']");
const input_cantidad_panos                        = document.querySelectorAll("input[name='cantidad-panos']");
const input_tipo_cortinas                         = document.querySelectorAll("input[name='tipo-cortinas']");
const input_mando_posiciones                      = document.querySelectorAll("input[name='mando-posiciones']");
const input_color_accesorios                      = document.querySelectorAll("input[name='color-accesorios']");
const input_cortina_instalaciones                 = document.querySelectorAll("input[name='cortina-instalaciones']");
const input_instalacion_tipos                     = document.querySelectorAll("input[name='instalacion-tipos']");
const input_instalacion_region                    = document.querySelector("select[name='instalacion-region']");
const input_instalacion_comuna                    = document.querySelector("select[name='instalacion-comuna']");
const input_instalacion_direccion                 = document.querySelector("input[name='instalacion-direccion']");
const input_nombre                                = document.querySelector("#nombre");
const input_mensaje                               = document.querySelector("#mensaje");
const reset_button                                = document.querySelector(".botones .btn.volver");
// Cotización
const cotizacion_cortina_tipo                     = document.querySelector(".val-cortina-tipo");
const cotizacion_ancho                            = document.querySelector(".val-ancho");
const cotizacion_alto                             = document.querySelector(".val-alto");
const cotizacion_tela_tipo                        = document.querySelector(".val-tela-tipo");
const cotizacion_tela_suboption                   = document.querySelector(".val-tela-suboption");
const cotizacion_cantidad_pano                    = document.querySelector(".val-cantidad-pano");
const cotizacion_tipo_cortina                     = document.querySelector(".val-tipo-cortina");
const cotizacion_accionamiento_tipo               = document.querySelector(".val-accionamiento-tipo");
const cotizacion_caida_sentido                    = document.querySelector(".val-caida-sentido");
const cotizacion_color_accesorio                  = document.querySelector(".val-color-accesorio");
const cotizacion_posicion_mando                   = document.querySelector(".val-posicion-mando");
const cotizacion_instalacion_cortina              = document.querySelector(".val-instalacion-cortina");
const cotizacion_instalacion                      = document.querySelector(".val-instalacion");
// Formulario Cotizado
const form_cotizado_cortina_tipo                  = document.querySelector("input[name='form-cortina-tipo']");
const form_cotizado_ancho                         = document.querySelector("input[name='form-ancho']");
const form_cotizado_alto                          = document.querySelector("input[name='form-alto']");
const form_cotizado_tela_tipo                     = document.querySelector("input[name='form-tela-tipo']");
const form_cotizado_tela_suboption                = document.querySelector("input[name='form-tela-suboption']");
const form_cotizado_tela_opcion_color             = document.querySelector("input[name='form-tela-opcion-color']");
const form_cotizado_accionamiento_tipo            = document.querySelector("input[name='form-accionamiento-tipo']");
const form_cotizado_caida_sentido                 = document.querySelector("input[name='form-caida-sentido']");
const form_cotizado_cantidad_pano                 = document.querySelector("input[name='form-cantidad-pano']");
const form_cotizado_tipo_cortina                  = document.querySelector("input[name='form-tipo-cortina']");
const form_cotizado_mando_posicion                = document.querySelector("input[name='form-mando-posicion']");
const form_cotizado_color_accesorio               = document.querySelector("input[name='form-color-accesorio']");
const form_cotizado_cortina_instalacion           = document.querySelector("input[name='form-cortina-instalacion']");
const form_cotizado_instalacion                   = document.querySelector("input[name='form-instalacion']");
const form_cotizado_instalacion_region            = document.querySelector("input[name='form-instalacion-region']");
const form_cotizado_instalacion_comuna            = document.querySelector("input[name='form-instalacion-comuna']");
const form_cotizado_instalacion_direccion         = document.querySelector("input[name='form-instalacion-direccion']");
const form_cotizado_nombre                        = document.querySelector("input[name='form-nombre']");
const form_cotizado_mensaje                       = document.querySelector("input[name='form-mensaje']");
const form_cotizado_homologado_venta              = document.querySelector("input[name='form-homologado-venta']");
// Hidden Form Productos
const hidden_form_producto_sujetador_cadena       = document.querySelector("input[name='product-sujetador-cadena']");
const hidden_form_producto_unidad_control         = document.querySelector("input[name='product-unidad-control']");
const hidden_form_producto_cadena                 = document.querySelector("input[name='product-cadena']");
const hidden_form_producto_cierre_cadena          = document.querySelector("input[name='product-cierre-cadena']");
const hidden_form_producto_clip_tope              = document.querySelector("input[name='product-clip-tope']");
const hidden_form_producto_terminal_riel_inferior = document.querySelector("input[name='product-terminal-riel-inferior']");
const hidden_form_producto_riel_inferior          = document.querySelector("input[name='product-riel-inferior']");
const hidden_form_producto_tubo                   = document.querySelector("input[name='product-tubo']");
const hidden_form_producto_motor                  = document.querySelector("input[name='product-motor']");
const hidden_form_producto_tela_roller            = document.querySelector("input[name='product-tela-roller']");
const hidden_form_producto_zuncho                 = document.querySelector("input[name='product-zuncho']");
const hidden_form_producto_confeccion             = document.querySelector("input[name='product-confeccion']");
const hidden_form_producto_instalacion            = document.querySelector("input[name='producto-instalacion']");
const hidden_form_producto_peso_envio             = document.querySelector("input[name='producto-peso-envio']");
// Hidden Form Productos Duo
const hidden_form_producto_unidad_control_duo     = document.querySelector("input[name='product-unidad-control-duo']");
const hidden_form_producto_riel_cenefa_duo        = document.querySelector("input[name='product-riel-cenefa-duo']");
const hidden_form_producto_bracket_duo            = document.querySelector("input[name='product-bracket-duo']");
const hidden_form_producto_riel_inferior_duo      = document.querySelector("input[name='product-riel-inferior-duo']");
const hidden_form_producto_riel_tubo_inferior_duo = document.querySelector("input[name='product-riel-tubo-inferior-duo']");
const hidden_form_producto_set_terminal_duo       = document.querySelector("input[name='product-set-terminal-duo']");
const hidden_form_producto_sujetador_cadena_duo   = document.querySelector("input[name='product-sujetador-cadena-duo']");
const hidden_form_producto_tubo_duo               = document.querySelector("input[name='product-tubo-duo']");
const hidden_form_producto_cierre_cadena_duo      = document.querySelector("input[name='product-cierre-cadena-duo']");
const hidden_form_producto_clip_tope_duo          = document.querySelector("input[name='product-clip-tope-duo']");
const hidden_form_producto_cadena_duo             = document.querySelector("input[name='product-cadena-duo']");
const hidden_form_producto_motor_duo              = document.querySelector("input[name='product-motor-duo']");
const hidden_form_producto_tela_roller_duo        = document.querySelector("input[name='product-tela-roller-duo']");
const hidden_form_producto_confeccion_duo         = document.querySelector("input[name='product-confeccion-duo']");
const hidden_form_producto_instalacion_duo        = document.querySelector("input[name='producto-instalacion-duo']");
const hidden_form_producto_peso_envio_duo         = document.querySelector("input[name='producto-peso-envio-duo']");
// Hidden Form Productos Tradicional
const hidden_form_producto_tela_trd               = document.querySelector("input[name='product-tela-tradicional']");
const hidden_form_producto_confeccion_trd         = document.querySelector("input[name='product-confeccion-tradicional']");
const hidden_form_producto_instalacion_trd        = document.querySelector("input[name='producto-instalacion-tradicional']");
const hidden_form_producto_peso_envio_trd         = document.querySelector("input[name='producto-peso-envio-tradicional']");
// Hidden Productos ?
const hidden_producto_sujetador_cadena            = document.querySelector(".normal-products .product-sujetador-cadena");
const hidden_producto_unidad_control              = document.querySelectorAll(".normal-products .product-unidad-control"); // Color Accesorio
const hidden_producto_cadena                      = document.querySelectorAll(".normal-products .product-cadena"); // Color Accesorio
const hidden_producto_cierre_cadena               = document.querySelectorAll(".normal-products .product-cierre-cadena"); // Color Accesorio
const hidden_producto_clip_tope                   = document.querySelectorAll(".normal-products .product-clip-tope"); // Color Accesorio
const hidden_producto_terminal_riel_inferior      = document.querySelectorAll(".normal-products .product-terminal-riel-inferior"); // Color Accesorio
const hidden_producto_riel_inferior               = document.querySelector(".normal-products .product-riel-inferior"); // Color Accesorio
const hidden_producto_tubo                        = document.querySelector(".normal-products .product-tubo");
const hidden_producto_motor                       = document.querySelector(".normal-products .product-motor");
const hidden_producto_tela_roller                 = document.querySelectorAll(".normal-products .product-tela-roller"); // Color-Tipo Tela
const hidden_producto_zuncho                      = document.querySelector(".product-zuncho");
const hidden_producto_confeccion                  = document.querySelector(".product-confeccion");
const hidden_producto_instalacion                 = document.querySelector(".product-instalacion");
// Hidden Productos Duo ?
const hidden_producto_unidad_control_duo          = document.querySelector(".duo-products .product-unidad-control-duo"); // Color Accesorio
const hidden_producto_riel_cenefa_duo             = document.querySelectorAll(".duo-products .product-riel-cenefa-duo"); // Color Accesorio
const hidden_producto_bracket_duo                 = document.querySelector(".duo-products .product-bracket-duo"); // Color Accesorio
const hidden_producto_riel_inferior_duo           = document.querySelector(".duo-products .product-riel-inferior-duo"); // Color Accesorio
const hidden_producto_riel_tubo_inferior_duo      = document.querySelector(".duo-products .product-riel-tubo-inferior-duo"); // Color Accesorio
const hidden_producto_set_terminal_duo            = document.querySelector(".duo-products .product-set-terminal-duo"); // Color Accesorio
const hidden_producto_sujetador_cadena_duo        = document.querySelector(".duo-products .product-sujetador-cadena-duo"); // Color Accesorio
const hidden_producto_tubo_duo                    = document.querySelector(".duo-products .product-tubo-duo"); // Color Accesorio
const hidden_producto_cierre_cadena_duo           = document.querySelectorAll(".duo-products .product-cierre-cadena-duo"); // Color Accesorio
const hidden_producto_clip_tope_duo               = document.querySelectorAll(".duo-products .product-clip-tope-duo"); // Color Accesorio
const hidden_producto_cadena_duo                  = document.querySelectorAll(".duo-products .product-cadena-duo"); // Color Accesorio
const hidden_producto_tela_roller_duo             = document.querySelectorAll(".duo-products .product-tela-roller-duo"); // Color Accesorio
const hidden_producto_motor_duo                   = document.querySelector(".duo-products .product-motor-duo"); // Color Accesorio
const hidden_producto_confeccion_duo              = document.querySelector(".product-confeccion-duo"); // Color Accesorio
const hidden_producto_instalacion_duo             = document.querySelector(".product-instalacion-duo"); // Color Accesorio
// Hidden Productos Trd ?
let hidden_producto_tela_trd                      = document.querySelectorAll(".tradicional-products .product-tela-tradicional-tradicional"); // Color-Tipo Tela
let hidden_producto_confeccion_trd                = document.querySelector(".product-confeccion-tradicional");
let hidden_producto_instalacion_trd               = document.querySelector(".tradicional-instalacion-tradicional");
// print cotización area
const hidden_cotizacion_area                      = document.querySelector(".inner-cotizacion-content");
const cotiza_container                            = document.querySelector(".cotiza-cortina");

async function initCotizadorBootstrapData() {
  if (typeof fetchCotizadorBootstrap !== "function") {
    console.error("No existe helper fetchCotizadorBootstrap");
    return;
  }

  const bootstrap = await fetchCotizadorBootstrap({ container: cotiza_container });
  if (bootstrap && typeof applyCotizadorBootstrapToDom === "function") {
    applyCotizadorBootstrapToDom(bootstrap);
  }
}

button_submit.addEventListener("click", submitCotizacion);

// Acordeon
if (cotiza_titles.length > 0) {
  cotiza_titles.forEach(cotiza_title => {
    cotiza_title.addEventListener("click", toggleTitle);
  });
}

if (cotiza_subtitles.length > 0) {
  cotiza_subtitles.forEach(cotiza_subtitle => {
    cotiza_subtitle.addEventListener("click", toggleSubtitle);
  });
}

if (label_radios.length > 0) {
  label_radios.forEach(label_radio => {
    label_radio.addEventListener("click", activeLabelRadio);
  });
}

if (input_tela_suboptions.length > 0) {
  input_tela_suboptions.forEach(input_tela_suboption => {
    input_tela_suboption.addEventListener("click", activeTelaSuboption);
  });
}

reset_button.addEventListener("click", resetForm);

if (region_select !== null) {
  region_select.addEventListener("change", setRegion);
}

// Onload
window.addEventListener("load", loadBase);

// Formulario
if (input_cortina_tipos.length > 0) {
  input_cortina_tipos.forEach(input_cortina_tipo => {
    input_cortina_tipo.addEventListener("change", setCotizacionCortinaTipo);
  });
}

if (input_sucursal.length > 0) {
  input_sucursal.addEventListener("change", setCotizacionSucursal);
}

if (input_ancho !== null) {
  input_ancho.addEventListener("change", setCotizacionAncho);
  input_ancho.addEventListener("blur", setCotizacionAncho);
}
if (input_alto !== null) {
  input_alto.addEventListener("change", setCotizacionAlto);
  input_alto.addEventListener("blur", setCotizacionAlto);
}

if (input_tela_tipos.length > 0) {
  input_tela_tipos.forEach(input_tela_tipo => {
    input_tela_tipo.addEventListener("click", setCotizacionTelaTipo);
    input_tela_tipo.addEventListener("change", setCotizacionTelaTipo);
  });
}

if (input_tela_suboptions.length > 0) {
  input_tela_suboptions.forEach(input_tela_suboption => {
    input_tela_suboption.addEventListener("change", setCotizacionTelaSuboption);
  });
}

if (input_tela_opcion_colores.length > 0) {
  document.querySelectorAll("input[name='tela-opcion-colores']").forEach(input_tela_opcion_color => {
    input_tela_opcion_color.addEventListener("change", setCotizacionTelaOptionColor);
  });
}

if (input_tipo_cortinas.length > 0) {
  input_tipo_cortinas.forEach(input_tipo_cortina => {
    input_tipo_cortina.addEventListener("change", setCotizacionTipoCortina);
  });
}

if (input_cantidad_panos.length > 0) {
  input_cantidad_panos.forEach(input_cantidad_pano => {
    input_cantidad_pano.addEventListener("change", setCotizacionCantidadPano);
  });
}

if (input_accionamiento_tipos.length > 0) {
  input_accionamiento_tipos.forEach(input_accionamiento_tipo => {
    input_accionamiento_tipo.addEventListener("change", setCotizacionAccionamientoTipo);
  });
}

if (input_caida_sentidos.length > 0) {
  input_caida_sentidos.forEach(input_caida_sentido => {
    input_caida_sentido.addEventListener("change", setCotizacionCaidaSentido);
  });
}

if (input_mando_posiciones.length > 0) {
  input_mando_posiciones.forEach(input_mando_posicion => {
    input_mando_posicion.addEventListener("change", setCotizacionPosicionMando);
  });
}

if (input_color_accesorios.length > 0) {
  input_color_accesorios.forEach(input_color_accesorio => {
    input_color_accesorio.addEventListener("change", setCotizacionColorAccesorio);
  });
}

if (input_cortina_instalaciones.length > 0) {
  input_cortina_instalaciones.forEach(input_cortina_instalacion => {
    input_cortina_instalacion.addEventListener("change", setCotizacionInstalacionCortina);
  });
}

if (input_instalacion_tipos.length > 0) {
  input_instalacion_tipos.forEach(input_instalacion_tipo => {
    input_instalacion_tipo.addEventListener("change", setCotizacionInstalacionTipo);
  });
}

if (input_instalacion_region !== null) {
  input_instalacion_region.addEventListener("change", setCotizacionInstalacionRegion);
}
if (input_instalacion_comuna !== null) {
  input_instalacion_comuna.addEventListener("change", setCotizacionInstalacionComuna);
}
if (input_instalacion_direccion !== null) {
  input_instalacion_direccion.addEventListener("change", setCotizacionInstalacionDireccion);
}
if (input_instalacion_region !== null) {
  input_instalacion_direccion.addEventListener("input", setCotizacionInstalacionDireccion);
}

if (input_nombre !== null) {
  input_nombre.addEventListener("change", setCotizacionNombre);
}
if (input_mensaje !== null) {
  input_mensaje.addEventListener("change", setCotizacionMensaje);
}

// Acordeon
function toggleTitle(event) {
  closeAllTitles(this);
  let cotiza_content = this.nextElementSibling;
  this.classList.toggle("active");
  if (this.parentNode.classList.contains("active")) {
    this.parentNode.classList.remove("active");
    cotiza_content.style.maxHeight = null;
  } else {
    this.parentNode.classList.add("active");
    cotiza_content.style.maxHeight = cotiza_content.scrollHeight + "px";
  }
}

function openTitle(object) {
  let cotiza_content = object.nextElementSibling;
  object.parentNode.classList.add("active");
  object.classList.add("active");
  cotiza_content.style.maxHeight = cotiza_content.scrollHeight + "px";
}

function openAllTitles() {
  cotiza_titles.forEach(object => {
    let cotiza_content = object.nextElementSibling;
    object.parentNode.classList.add("active");
    object.classList.add("active");
    cotiza_content.style.maxHeight = cotiza_content.scrollHeight + "px";
  });
}

function closeTitle(object) {
  let cotiza_content = object.nextElementSibling;
  object.parentNode.classList.remove("active");
  object.classList.remove("active");
  cotiza_content.style.maxHeight = null;
}

function closeAllTitles($_this) {
  cotiza_titles.forEach(object => {
    if ($_this === undefined) {
      let cotiza_content = object.nextElementSibling;
      object.parentNode.classList.remove("active");
      object.classList.remove("active");
      cotiza_content.style.maxHeight = null;
    } else {
      if (object.dataset.optionNumber !== $_this.dataset.optionNumber) {
        let cotiza_content = object.nextElementSibling;
        object.parentNode.classList.remove("active");
        object.classList.remove("active");
        cotiza_content.style.maxHeight = null;
      }
    }
  });
}

function toggleSubtitle(event) {
  let cotiza_option = this.nextElementSibling;
  if (this.classList.contains("active")) {
    this.classList.remove("active");
    this.parentNode.classList.remove("active");
    cotiza_option.style.maxHeight = null;
  } else {
    this.classList.add("active");
    this.parentNode.classList.add("active");
    cotiza_option.style.maxHeight = cotiza_option.scrollHeight + "px";
  }
}

function openSubtitle(object) {
  let cotiza_option = object.nextElementSibling;
  object.classList.add("active");
  if (cotiza_option.style.maxHeight) {
    cotiza_option.style.maxHeight = null;
  } else {
    cotiza_option.style.maxHeight = cotiza_option.scrollHeight + "px";
  }
}

function openAllSubtitles() {
  cotiza_subtitles.forEach(object => {
    let cotiza_option = object.nextElementSibling;
    object.classList.add("active");
    if (cotiza_option.style.maxHeight) {
      cotiza_option.style.maxHeight = null;
    } else {
      cotiza_option.style.maxHeight = cotiza_option.scrollHeight + "px";
    }
  });
}

function closeSubtitle(object) {
  let cotiza_option = object.nextElementSibling;
  object.classList.remove("active");
  if (cotiza_option.style.maxHeight) {
    cotiza_option.style.maxHeight = null;
  } else {
    cotiza_option.style.maxHeight = cotiza_option.scrollHeight + "px";
  }
}

function closeAllSubtitles() {
  cotiza_subtitles.forEach(object => {
    let cotiza_option = object.nextElementSibling;
    object.classList.remove("active");
    if (cotiza_option.style.maxHeight) {
      cotiza_option.style.maxHeight = null;
    } else {
      cotiza_option.style.maxHeight = cotiza_option.scrollHeight + "px";
    }
  });
}

function activeLabelRadio(event) {
  let node_clicked = this.nodeName;
  let selectedInput = this.previousElementSibling;
  let selectedSuboption = this.closest(".suboptions");
  let selectedSuboptionInput = selectedSuboption ? selectedSuboption.querySelector("input[name='tela-suboptions']") : null;

  if (selectedInput && selectedInput.name == "tela-opcion-colores") {
    event.preventDefault();
    if (selectedSuboption && selectedSuboptionInput) {
      turnOffSuboptions();
      selectedSuboption.classList.add("active");
      selectedSuboptionInput.checked = true;
      setFormCotizadoTelaSuboption(selectedSuboptionInput);
    }
    selectedInput.checked = true;
  }

  switch(node_clicked) {
    case 'IMG':
      if (this.parentNode.parentNode.parentNode.classList.contains("active")) {
        turnOffRadios();
        this.parentNode.classList.add("active");
        turnOffSuboptions();
        this.parentNode.parentNode.parentNode.classList.add("active");
      }
      break;
    case 'LABEL':
      if (this.parentNode.parentNode.classList.contains("active")) {
        turnOffRadios();
        this.classList.add("active");
        turnOffSuboptions();
        this.parentNode.parentNode.classList.add("active");
      }
      break;
    case 'SPAN':
      if (this.parentNode.parentNode.parentNode.classList.contains("active")) {
        let screen_plus = document.getElementById("screen_plus");
        turnOffRadios();
        this.parentNode.classList.add("active");
        turnOffSuboptions();
        this.parentNode.parentNode.parentNode.classList.add("active");
        screen_plus.setAttribute("checked", "checked");
      }
      break;
  }

  if (selectedInput && selectedInput.name == "tela-opcion-colores") {
    turnOffRadios();
    this.classList.add("active");
    selectedInput.dispatchEvent(new Event('change'));
  }
}

function activeTelaSuboption(event) {
  turnOffSuboptions();
  turnOffRadios();
  this.parentNode.parentNode.parentNode.classList.add("active");
  let flag = true;
  document.querySelectorAll(".suboptions.active .label-colores").forEach(label_radio => {
    if (window.getComputedStyle(label_radio).display !== "none" && flag) {
      flag = false;
      label_radio.classList.add("active");
      label_radio.previousElementSibling.checked = true;
      label_radio.previousElementSibling.dispatchEvent(new Event('change'));
      return false;
    }
  });
}

function turnOffRadios() {
  document.querySelectorAll(".label-colores").forEach(label_radio => {
    label_radio.classList.remove("active");
  });
}

function turnOffSuboptions() {
  input_tela_suboptions.forEach(input_tela_suboption => {
    input_tela_suboption.parentNode.parentNode.parentNode.classList.remove("active");
  });
}

function syncFormStock() {
  let tipo_cortina = document.querySelector("input[name='cortina-tipos']:checked").dataset.value;
  switch(tipo_cortina) {
    case 'roller':
      input_color_accesorios.forEach(input_color_accesorio => {
        input_color_accesorio.classList.remove("hide");
        input_color_accesorio.nextElementSibling.classList.remove("hide");
        if (document.querySelectorAll(`.normal-products .product-unidad-control[data-product-color='${input_color_accesorio.dataset.value}']`).length == 0) {
          input_color_accesorio.classList.add("hide");
          input_color_accesorio.nextElementSibling.classList.add("hide");
        }
        if (document.querySelectorAll(`.normal-products .product-cadena[data-product-color='${input_color_accesorio.dataset.value}']`).length == 0) {
          input_color_accesorio.classList.add("hide");
          input_color_accesorio.nextElementSibling.classList.add("hide");
        }
        if (document.querySelectorAll(`.normal-products .product-cierre-cadena[data-product-color='${input_color_accesorio.dataset.value}']`).length == 0) {
          input_color_accesorio.classList.add("hide");
          input_color_accesorio.nextElementSibling.classList.add("hide");
        }
        if (document.querySelectorAll(`.normal-products .product-clip-tope[data-product-color='${input_color_accesorio.dataset.value}']`).length == 0) {
          input_color_accesorio.classList.add("hide");
          input_color_accesorio.nextElementSibling.classList.add("hide");
        }
        if (document.querySelectorAll(`.normal-products .product-terminal-riel-inferior[data-product-color='${input_color_accesorio.dataset.value}']`).length == 0) {
          input_color_accesorio.classList.add("hide");
          input_color_accesorio.nextElementSibling.classList.add("hide");
        }
        if (document.querySelectorAll(`.normal-products .product-riel-inferior[data-product-color='${input_color_accesorio.dataset.value}']`).length == 0) {
          input_color_accesorio.classList.add("hide");
          input_color_accesorio.nextElementSibling.classList.add("hide");
        }
      });
      break;
    case 'roller-duo':
      input_color_accesorios.forEach(input_color_accesorio => {
        input_color_accesorio.classList.remove("hide");
        input_color_accesorio.nextElementSibling.classList.remove("hide");
        if (document.querySelectorAll(`.duo-products .product-unidad-control-duo[data-product-color='${input_color_accesorio.dataset.value}']`).length == 0) {
          input_color_accesorio.classList.add("hide");
          input_color_accesorio.nextElementSibling.classList.add("hide");
        }
        if (document.querySelectorAll(`.duo-products .product-riel-cenefa-duo[data-product-color='${input_color_accesorio.dataset.value}']`).length == 0) {
          input_color_accesorio.classList.add("hide");
          input_color_accesorio.nextElementSibling.classList.add("hide");
        }
        if (document.querySelectorAll(`.duo-products .product-cierre-cadena-duo[data-product-color='${input_color_accesorio.dataset.value}']`).length == 0) {
          input_color_accesorio.classList.add("hide");
          input_color_accesorio.nextElementSibling.classList.add("hide");
        }
        if (document.querySelectorAll(`.duo-products .product-clip-tope-duo[data-product-color='${input_color_accesorio.dataset.value}']`).length == 0) {
          input_color_accesorio.classList.add("hide");
          input_color_accesorio.nextElementSibling.classList.add("hide");
        }
        if (document.querySelectorAll(`.duo-products .product-cadena-duo[data-product-color='${input_color_accesorio.dataset.value}']`).length == 0) {
          input_color_accesorio.classList.add("hide");
          input_color_accesorio.nextElementSibling.classList.add("hide");
        }
      });
      break
  }
  setTelaHeight();
}

// Onload
async function loadBase() {
  await initCotizadorBootstrapData();
  hydrateBootstrapTradicionalComponents();
  refreshHiddenProductoTradicionalRefs();
  let reset_form = findGetParameter("reset_form");
  let tipo_cotizador = document.querySelector(".cotiza51").dataset.cotizador;
  if (reset_form !== null) {
    if (reset_form == "true") {
      let top_element = document.querySelector(".cortina-type").getBoundingClientRect().top;
      let header_height = document.querySelector("#shopify-section-header header").offsetHeight;
      window.scrollBy({
        top: top_element - header_height, // could be negative value
        left: 0,
        behavior: 'smooth'
      });
      window.history.replaceState({}, document.title, new URL(document.URL).pathname);
    }
  }

  let cotiza_content = document.querySelector(".cotiza-cortina .content");
  if (cotiza_content.style.maxHeight) {
    cotiza_content.style.maxHeight = null;
  } else {
    cotiza_content.style.maxHeight = cotiza_content.scrollHeight + "px";
  }

  if (tipo_cotizador === "roller") {
    if (document.querySelector(".val-tipo-cortina") !== null) {
      document.querySelector(".val-tipo-cortina").parentNode.classList.add("not-show");
    }
    if (document.querySelector(".val-cantidad-pano") !== null) {
      document.querySelector(".val-cantidad-pano").parentNode.classList.add("not-show");
    }
  } else if (tipo_cotizador === "tradicional") {
    document.querySelector(".cotiza-tela-suboption .title-select-h4").textContent = "Selecciona Tela";
    if (document.querySelector(".val-accionamiento-tipo") !== null) {
      document.querySelector(".val-accionamiento-tipo").parentNode.classList.add("not-show");
    }
    if (document.querySelector(".val-caida-sentido") !== null) {
      document.querySelector(".val-caida-sentido").parentNode.classList.add("not-show");
    }
    if (document.querySelector(".val-color-accesorio") !== null) {
      document.querySelector(".val-color-accesorio").parentNode.classList.add("not-show");
    }
    if (document.querySelector(".val-confeccion-tipo") !== null) {
      document.querySelector(".val-confeccion-tipo").parentNode.classList.add("not-show");
    }
    if (document.querySelector(".val-posicion-mando") !== null) {
      document.querySelector(".val-posicion-mando").parentNode.classList.add("not-show");
    }
    if (document.querySelector(".val-instalacion") !== null) {
      document.querySelector(".val-instalacion").parentNode.classList.add("not-show");
    }
    if (document.querySelector(".val-instalacion-cortina") !== null) {
      document.querySelector(".val-instalacion-cortina").parentNode.classList.add("not-show");
    }
  }

  loadCortinas();

  setCortinaTipo(input_cortina_tipos[0].value);
  setFormCotizadoCortinaTipo(input_cortina_tipos[0]);
  setAncho(`${input_ancho.value} cm`);
  setFormCotizadoAncho(input_ancho.value);
  setAlto(`${input_alto.value} cm`);
  setFormCotizadoAlto(input_alto.value);
  setTelaTipo(input_tela_tipos[0].value);
  setFormCotizadoTelaTipo(input_tela_tipos[0]);
  setTelaSuboption(input_tela_suboptions[0].value);
  setFormCotizadoTelaSuboption(input_tela_suboptions[0]);
  setFormCotizadoNombre(input_nombre.value);
  setFormCotizadoMensaje(input_mensaje.value);

  setCantidadPano(input_cantidad_panos[0].value);
  setFormCotizadoCantidadPano(input_cantidad_panos[0]);
  setTipoCortina(input_tipo_cortinas[0].value);
  setFormCotizadoTipoCortina(input_tipo_cortinas[0]);

  checkFormCotizacion();
  setForm();
}

function setRegion() {
  if (region_select.value !== '1') {
    radio_message_container.classList.add("show");
    radio_container.classList.remove("show");
    address_container.classList.remove("show");
    input_instalacion_tipos[1].checked = true;
    input_instalacion_tipos[1].dispatchEvent(new Event('change'));
  } else {
    radio_message_container.classList.remove("show");
    radio_container.classList.add("show");
    address_container.classList.add("show");
    input_instalacion_tipos[0].checked = true;
    input_instalacion_tipos[0].dispatchEvent(new Event('change'));
  }
}

// Click Reset
function resetForm() {
  let cotiza_content = document.querySelector(".cotiza-cortina .content");
  if (cotiza_content.style.maxHeight) {
    cotiza_content.style.maxHeight = null;
  } else {
    cotiza_content.style.maxHeight = cotiza_content.scrollHeight + "px";
  }
  setInputCortinaTipo(0);
  setInputAncho("40");
  setInputAlto("40");
  setInputTelaTipo(indexInParent(getCurrentRadioWrap()));
  setInputAccionamientoTipo(0);
  setInputCaidaSentido(0);
  setInputColorAccesorio(indexInParent(getCurrentColorAccesorio()));
  setInputPosicionMando(0);
  setInputInstalacionCortina(0);
  setInputNombre("");
  setInputMensaje("");
  closeAllSubtitles();
  closeAllTitles();
  openTitle(document.querySelector(".title-select-h1[data-option-number='1']"));

  let top_element = document.querySelector(".cortina-type").getBoundingClientRect().top;
  let header_height = document.querySelector("#shopify-section-header header").offsetHeight;
  window.scrollBy({
    top: top_element - header_height, // could be negative value
    left: 0,
    behavior: 'smooth'
  });
}

function checkFormCotizacion() {
  syncFormStock();
  // Bloques
  let cotiza_active_blocks = document.querySelectorAll(`.cotiza-cortina[data-cortina-${form_cotizado_cortina_tipo.value}="true"]`);
  if (cotiza_active_blocks.length > 0) {
    turnOnCotizaParentParentBlocks(cotiza_active_blocks);
  }
  // Tela Tipo
  turnOffAllTelaTipoBlocks(input_tela_tipos);
  turnOnStockTelaTipoBlocks(input_tela_tipos);
}

function turnOnStockTelaTipoBlocks(cotiza_tela_tipo_blocks) {
  let tipo_cortina = form_cotizado_cortina_tipo.value;
  let colores  = document.querySelectorAll(".tela-opcion-colores");
  let opciones = document.querySelectorAll(".tela-suboptions");
  cotiza_tela_tipo_blocks.forEach(cotiza_tela_tipo_block => {
    let tela = cotiza_tela_tipo_block.dataset.value;
    opciones.forEach(options => {
      let tipo = options.dataset.value;
      let length_products = 0;
      colores.forEach(colors => {
        let color = colors.dataset.value;

        options.parentNode.parentNode.parentNode.classList.remove("hide");
        length_products = document.querySelectorAll(`.tradicional-products .product-tela-tradicional-tradicional[data-product-tela='${tela}'][data-product-tipo='${tipo}'][data-product-color='${color}']`).length;
        if (length_products > 0) {
          options.parentNode.parentNode.parentNode.classList.remove("hide");
        }

        if (length_products > 0) {
          cotiza_tela_tipo_block.parentNode.classList.add("show");
        }
      });
    });
  });
  let eClick     = new Event('click');
  let eChange    = new Event('change');
  let radio_wrap = document.querySelectorAll(".radios .radio-wrap.show .tela-tipos");
  if (radio_wrap.length > 0) {
    radio_wrap[0].checked = true;
    radio_wrap[0].dispatchEvent(eClick);
    radio_wrap[0].dispatchEvent(eChange);
  }
}

function turnOffAllTelaTipoBlocks(tela_tipo_blocks) {
  tela_tipo_blocks.forEach(tela_tipo_block => {
    tela_tipo_block.parentNode.classList.remove("show");
  });
}

function turnOnCotizaParentParentBlocks(cotiza_blocks) {
  cotiza_blocks.forEach(cotiza_block => {
    cotiza_block.parentNode.parentNode.classList.add("show");
  });
  let theTitle = document.querySelector(".option.active .title-select-h1") ? document.querySelector(".option.active .title-select-h1") : document.querySelector(".option .title-select-h1");
  openTitle(theTitle);
}

function turnOffAllCotizaBlocks(cotiza_blocks) {
  cotiza_blocks.forEach(cotiza_block => {
    cotiza_block.classList.remove("show");
  });
}

function checkCotizaSinStock(params) {
  return true;
}

function setForm() {
  let response = true;
  if (checkCotizaSinStock()) {
    setHiddenFormProductoInputConfeccionTradicional({"input": input_sucursal, "value": input_sucursal.value});
    calculateTelaTradicional({"input": getHiddenProductoTelaTradicional()});
    calculateTotalWeightTradicional({"tela": getHiddenProductoTelaTradicional()});
    calculateConfeccionTradicional({"input": hidden_producto_confeccion_trd});

    setHiddenFormProductoInstalacionTradicional({"value": form_cotizado_instalacion.value});

    calculaCotizacion();
  } else {
    response = false;
  }
  return response;
}

// Cotizador Input
function setInputCortinaTipo(value) {
  input_cortina_tipos[value].checked = true;
  input_cortina_tipos[value].dispatchEvent(new Event('change'));
}

function setInputAncho(value) {
  input_ancho.value = value;
  input_ancho.dispatchEvent(new Event('change'));
}

function setInputAlto(value) {
  input_alto.value = value;
  input_alto.dispatchEvent(new Event('change'));
}

function setInputTelaTipo(value) {
  input_tela_tipos[value].checked = true;
  input_tela_tipos[value].dispatchEvent(new Event('change'));
}

function setInputAccionamientoTipo(value) {
  input_accionamiento_tipos[value].checked = true;
  input_accionamiento_tipos[value].dispatchEvent(new Event('change'));
}

function setInputCaidaSentido(value) {
  input_caida_sentidos[value].checked = true;
  input_caida_sentidos[value].dispatchEvent(new Event('change'));
}

function setInputColorAccesorio(value) {
  input_color_accesorios[value].checked = true;
  input_color_accesorios[value].dispatchEvent(new Event('change'));
}

function setInputPosicionMando(value) {
  input_mando_posiciones[value].checked = true;
  input_mando_posiciones[value].dispatchEvent(new Event('change'));
}

function setInputInstalacionCortina(value) {
  input_cortina_instalaciones[value].checked = true;
  input_cortina_instalaciones[value].dispatchEvent(new Event('change'));
}

function setInputNombre(value) {
  input_nombre.value = value;
  input_nombre.dispatchEvent(new Event('change'));
}

function setInputMensaje(value) {
  input_mensaje.value = value;
  input_mensaje.dispatchEvent(new Event('change'));
}

function getCotizadorProductDataset(product) {
  return product && product.dataset ? product.dataset : {};
}

function getTradicionalTelaProductsFromStore() {
  if (typeof findCotizadorProductGroup === "function") {
    const groupedProducts = findCotizadorProductGroup("tradicionalProducts", {
      productKey: "tradicional",
      containerClass: "tradicional-products",
      className: "product-tela-tradicional-tradicional"
    });
    if (groupedProducts.length > 0) return groupedProducts;
  }

  if (typeof findCotizadorProducts !== "function") return [];

  return findCotizadorProducts({
    productKey: "tradicional",
    containerClass: "tradicional-products",
    className: "product-tela-tradicional-tradicional"
  });
}

function findTradicionalTelaProductsFromStore(filters) {
  return getTradicionalTelaProductsFromStore().filter(product => {
    const dataset = getCotizadorProductDataset(product);
    return Object.keys(filters).every(key => !filters[key] || dataset[key] === filters[key]);
  });
}

function generateTelaColorHtml(input, index, telaType) {
  const dataset = getCotizadorProductDataset(input);

  return `<input type="radio" class="radio tela-opcion-colores tela-opcion-color-${telaType}" id="tela_opcion_colores_${index}" name="tela-opcion-colores" data-value="${dataset.productColor}" data-sku-softland="${dataset.skuSoftland}" data-sku="${dataset.productSku}" value="${dataset.productColorFull}">
      <label class="label-colores label-colores-${telaType}" for="tela_opcion_colores_${index}">
        <img src="${dataset.productImageTiny}" alt="${dataset.productTitle}" srcset="${dataset.productImageTiny}" width="29" height="29" loading="lazy">
        <span>${dataset.productColorFull}</span>
      </label>`;
}

function handleizeCotizadorValue(value) {
  return (value || "")
    .toString()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function getCotizadorBootstrapPayload() {
  return window.cotizadorBootstrapState && window.cotizadorBootstrapState.data ? window.cotizadorBootstrapState.data : null;
}

function getCotizadorBootstrapStockBySku(bootstrap) {
  const stock = bootstrap && Array.isArray(bootstrap.stock) ? bootstrap.stock : [];
  return new Map(stock.map(item => [(item.sku || "").toString().trim().toUpperCase(), item]));
}

function setBootstrapDatasetValue(input, key, value, transform) {
  if (value === undefined || value === null || value === "") return;
  input.dataset[key] = transform ? transform(value) : value.toString();
}

function applyBootstrapImagesToTradicionalInput(input, images) {
  const primary = images && images.primary ? images.primary : null;
  const secondary = images && images.secondary ? images.secondary : primary;
  const fallback = input.dataset.productImageTiny || "";

  setBootstrapDatasetValue(input, "productImage", secondary && secondary.previewUrl ? secondary.previewUrl : fallback);
  setBootstrapDatasetValue(input, "productImageZoom", secondary && secondary.zoomUrl ? secondary.zoomUrl : fallback);
  setBootstrapDatasetValue(input, "productImageExtra", primary && primary.previewUrl ? primary.previewUrl : fallback);
  setBootstrapDatasetValue(input, "productImageExtraZoom", primary && primary.zoomUrl ? primary.zoomUrl : fallback);
  setBootstrapDatasetValue(input, "productImageTiny", primary && primary.tinyUrl ? primary.tinyUrl : fallback);
}

function upsertBootstrapTelaTradicionalProduct(item, stockBySku) {
  const sku = (item.sku || "").toString().trim();
  const tela = handleizeCotizadorValue(item.categoria) || handleizeCotizadorValue(item.productKey) || "tradicional";
  const tipo = handleizeCotizadorValue(item.subtipo) || handleizeCotizadorValue(item.tipo);
  const color = handleizeCotizadorValue(item.color);
  const container = document.querySelector(".tradicional-products");

  if (!sku || !color || !container) return null;

  let input = container.querySelector(`.product-tela-tradicional-tradicional[data-product-sku='${sku}'][data-product-color='${color}']`);
  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = `producto-bootstrap-product-tela-tradicional-${sku}`;
    input.className = "product-tela-tradicional-tradicional";
    input.dataset.bootstrapCatalog = "true";
    container.appendChild(input);
  }

  const stock = stockBySku.get(sku.toUpperCase());
  const price = stock && Number.isFinite(Number(stock.price)) ? Number(stock.price) : Number(item.price || 0);
  const quantity = stock && Number.isFinite(Number(stock.quantity)) ? Number(stock.quantity) : Number(item.inventoryQuantity || 0);

  input.value = `${Math.round(price)}`;
  setBootstrapDatasetValue(input, "productSku", sku);
  setBootstrapDatasetValue(input, "productTitle", item.name);
  setBootstrapDatasetValue(input, "productTela", tela);
  setBootstrapDatasetValue(input, "productTipo", tipo);
  setBootstrapDatasetValue(input, "productColor", color);
  setBootstrapDatasetValue(input, "productColorFull", item.colorFull || item.color);
  setBootstrapDatasetValue(input, "skuSoftland", item.skuSoftland || sku);
  setBootstrapDatasetValue(input, "descripcionSoftland", (stock && stock.description) || item.descripcionSoftland || item.name);
  setBootstrapDatasetValue(input, "productWeight", item.weight || 0);
  setBootstrapDatasetValue(input, "productWeightUnit", item.weightUnit || "g");
  setBootstrapDatasetValue(input, "productQuantity", quantity);
  setBootstrapDatasetValue(input, "productAvailable", quantity > 0 ? "true" : "false");
  applyBootstrapImagesToTradicionalInput(input, item.images);

  return input;
}

function hydrateBootstrapTelaTradicionalProducts() {
  const bootstrap = getCotizadorBootstrapPayload();
  const catalog = bootstrap && Array.isArray(bootstrap.catalog) ? bootstrap.catalog : [];
  if (catalog.length === 0) return [];

  const stockBySku = getCotizadorBootstrapStockBySku(bootstrap);
  return catalog
    .map(item => upsertBootstrapTelaTradicionalProduct(item, stockBySku))
    .filter(Boolean);
}

function getBootstrapSoftlandSku(softland) {
  if (!softland) return "";
  return (softland.codRapido || softland.codBarra || "").toString().trim();
}

function normalizeComponentKey(value) {
  return (value || "")
    .toString()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .toLowerCase();
}

function handleizeCotizadorComponentKey(value) {
  return (value || "")
    .toString()
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

const tradicionalComponentClassByKey = {
  confeccion: "product-confeccion-tradicional",
  instalacion: "tradicional-instalacion-tradicional"
};

function buildTradicionalComponentClassName(key) {
  const normalizedKey = normalizeComponentKey(key);
  return tradicionalComponentClassByKey[normalizedKey] || `product-${handleizeCotizadorComponentKey(key)}-tradicional`;
}

function getBootstrapComponentStock(item, stockBySku) {
  const sku = (item.sku || "").toString().trim().toUpperCase();
  return sku ? stockBySku.get(sku) : null;
}

function upsertBootstrapTradicionalComponent(item, stockBySku) {
  const key = (item.key || "").toString().trim();
  const sku = (item.sku || "").toString().trim();
  const normalizedKey = normalizeComponentKey(key);
  const container = document.querySelector(".tradicional-products");
  if (!container || !key || !sku || normalizedKey.indexOf("tela") >= 0) return null;

  const className = buildTradicionalComponentClassName(key);
  let input = container.querySelector(`.${className}[data-product-sku='${sku}']`) || container.querySelector(`.${className}`);
  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = `producto-bootstrap-${className}-${sku}`;
    input.className = className;
    input.dataset.bootstrapComponent = "true";
    container.appendChild(input);
  }

  const stock = getBootstrapComponentStock(item, stockBySku);
  const price = Number.isFinite(Number(item.price)) ? Number(item.price) : (stock && Number.isFinite(Number(stock.price)) ? Number(stock.price) : 0);
  const quantity = Number.isFinite(Number(item.quantity)) ? Number(item.quantity) : (stock && Number.isFinite(Number(stock.quantity)) ? Number(stock.quantity) : Number(input.dataset.productQuantity || 0));

  input.value = `${Math.round(price)}`;
  setBootstrapDatasetValue(input, "productSku", sku);
  setBootstrapDatasetValue(input, "productTitle", item.name);
  setBootstrapDatasetValue(input, "skuSoftland", item.skuSoftland || getBootstrapSoftlandSku(item.softland) || sku);
  setBootstrapDatasetValue(input, "descripcionSoftland", item.descripcionSoftland || (stock && stock.description) || item.name);
  setBootstrapDatasetValue(input, "productQuantity", quantity);
  setBootstrapDatasetValue(input, "productAvailable", item.available === true || quantity > 0 ? "true" : (input.dataset.productAvailable || "false"));
  setBootstrapDatasetValue(input, "productWeight", Number.isFinite(Number(item.weight)) ? item.weight : (input.dataset.productWeight || 0));
  setBootstrapDatasetValue(input, "productWeightUnit", item.weightUnit || input.dataset.productWeightUnit || "g");
  setBootstrapDatasetValue(input, "compareAtPrice", item.compareAtPrice || (stock && stock.compareAtPrice));

  return input;
}

function hydrateBootstrapTradicionalComponents() {
  const bootstrap = getCotizadorBootstrapPayload();
  const componentes = bootstrap && Array.isArray(bootstrap.componentes) ? bootstrap.componentes : [];
  if (componentes.length === 0) return [];

  const stockBySku = getCotizadorBootstrapStockBySku(bootstrap);
  return componentes
    .filter(item => (item.productKey || "").toString().trim().toLowerCase() === "tradicional")
    .map(item => upsertBootstrapTradicionalComponent(item, stockBySku))
    .filter(Boolean);
}

function refreshHiddenProductoTradicionalRefs() {
  hidden_producto_tela_trd          = document.querySelectorAll(".tradicional-products .product-tela-tradicional-tradicional");
  hidden_producto_confeccion_trd    = document.querySelector(".tradicional-products .product-confeccion-tradicional") || document.querySelector(".product-confeccion-tradicional");
  hidden_producto_instalacion_trd   = document.querySelector(".tradicional-products .tradicional-instalacion-tradicional") || document.querySelector(".tradicional-instalacion-tradicional");
}

function getUniqueCotizadorProducts(products) {
  const seen = new Set();

  return products.filter(product => {
    const dataset = getCotizadorProductDataset(product);
    const key = [
      product.containerClass || "",
      product.className || "",
      dataset.productSku || product.name || "",
      dataset.productTela || "",
      dataset.productColor || ""
    ].join("|");

    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

function renderTelaColorOption(input, colorTelas, index, forcedType) {
  const dataset = getCotizadorProductDataset(input);
  if (!dataset.productColor || colorTelas.length === 0) return index;

  const telaType = forcedType || dataset.productTela || "tradicional";
  if (telaType !== "screen" && telaType !== "tradicional") {
    colorTelas[0].insertAdjacentHTML('beforeend', generateTelaColorHtml(input, index, telaType));
    return index + 1;
  }

  const targetColorTela = dataset.productTipo
    ? Array.from(colorTelas).find(colorTela => dataset.productTipo == colorTela.parentNode.dataset.productTipo)
    : colorTelas[0];

  if (targetColorTela) {
    targetColorTela.parentNode.classList.add("show");
    targetColorTela.insertAdjacentHTML('beforeend', generateTelaColorHtml(input, index, telaType));
    index++;
  }

  return index;
}

// Load Cortinas
function loadCortinas() {
  let index = 1;
  let color_telas = document.querySelectorAll(".cotiza-tela-color");
  const bootstrapTelaProducts = hydrateBootstrapTelaTradicionalProducts();
  refreshHiddenProductoTradicionalRefs();
  const storeTelaProducts = getTradicionalTelaProductsFromStore();
  const allTelaProducts = getUniqueCotizadorProducts(bootstrapTelaProducts.concat(storeTelaProducts));

  color_telas.forEach(color_tela => { color_tela.innerHTML = ""; });

  if (allTelaProducts.length > 0) {
    allTelaProducts.forEach(input => {
      index = renderTelaColorOption(input, color_telas, index, "tradicional");
    });
  } else {
    hidden_producto_tela_roller.forEach(input => {
      index = renderTelaColorOption(input, color_telas, index);
    });

    hidden_producto_tela_trd.forEach(input => {
      if (input.dataset.productTela && input.dataset.productTela.toLowerCase() == "tradicional") {
        index = renderTelaColorOption(input, color_telas, index, "tradicional");
      }
    });
  }

  document.querySelectorAll(".label-colores").forEach(label_radio => {
    label_radio.addEventListener("click", activeLabelRadio);
  });

  document.querySelectorAll("input[name='tela-opcion-colores']").forEach(input_tela_opcion_color => {
    input_tela_opcion_color.addEventListener("change", setCotizacionTelaOptionColor);
  });
}
// Formulario Input
function setCortinaTipo(value) {
  cotizacion_cortina_tipo.innerHTML = value;
}

function setAncho(value) {
  cotizacion_ancho.innerHTML = value;
}

function setAlto(value) {
  cotizacion_alto.innerHTML = value;
}

function setTelaTipo(value) {
  let tela_option    = document.querySelector("input[name='tela-tipos']:checked").dataset.value;
  let tela_suboption = document.querySelector("input[name='tela-suboptions']:checked").value;
  if (tela_option == "screen" || tela_option == "tradicional") {
    cotizacion_tela_tipo.innerHTML = `${value} - ${tela_suboption}`;
  } else {
    cotizacion_tela_tipo.innerHTML = value;
  }
}

function setTelaSuboption(value) {
  cotizacion_tela_suboption.innerHTML = value;
}

function setCantidadPano(value) {
  cotizacion_cantidad_pano.innerHTML = value;
}

function setTipoCortina(value) {
  cotizacion_tipo_cortina.innerHTML = value;
}

function setTelaOptionColor(value) {
  cotizacion_tela_suboption.innerHTML = value;
}

function setAccionamientoTipo(value) {
  cotizacion_accionamiento_tipo.innerHTML = value;
}

function setCaidaSentido(value) {
  cotizacion_caida_sentido.innerHTML = value;
}

function setColorAccesorio(value) {
  cotizacion_color_accesorio.innerHTML = value;
}

function setPosicionMando(value) {
  cotizacion_posicion_mando.innerHTML = value;
}

function setInstalacionCortina(value) {
  cotizacion_instalacion_cortina.innerHTML = value;
}

function setInstalacionTipo(value) {
  cotizacion_instalacion.innerHTML = value;
}

function setNombre(value) {
  form_nombre.value = value;
}

function setMensaje(value) {
  form_mensaje.value = value;
}

function setSkuSoftland() {
  console.log("Sku Softland!!!");
  const sku_softland = document.querySelector("input[name='tela-opcion-colores']:checked");

  if (sku_softland) {
    if (sku_softland.dataset.skuSoftland !== 'undefined') {
      form_cotizado_homologado_venta.value = sku_softland.dataset.skuSoftland;

      const radio = sku_softland.parentElement.parentElement
        .firstElementChild
        .getElementsByClassName("tela-suboptions")[0]; // accede al primero si hay más de uno

      if (radio) {
        radio.checked = true;
        // Crea un nuevo evento de cambio
        var event = new Event('change', {
          'bubbles': true,
          'cancelable': true
        });

        // Despacha el evento de cambio
        radio.dispatchEvent(event);
      }
    } else {
      form_cotizado_homologado_venta.value = '';
    }
  } else {
    form_cotizado_homologado_venta.value = '';
  }
}

// Formulario Cotizacion
function setCotizacionCortinaTipo(event) {
  setCortinaTipo(`${this.value}`);
  setFormCotizadoCortinaTipo(this);
  checkFormCotizacion();
  setSkuSoftland();
  setForm();
}

function setCotizacionAncho(event) {
  if (parseInt(this.value) <= parseInt(this.attributes.max.value) && parseInt(this.value) >= parseInt(this.attributes.min.value)) {
    setAncho(`${this.value} cm`);
    setFormCotizadoAncho(this.value);
    setForm();
  } else {
    if (parseInt(this.value) > parseInt(this.attributes.max.value)) {
      this.value = this.attributes.max.value;
    } else if (parseInt(this.value) < parseInt(this.attributes.min.value)) {
      this.value = this.attributes.min.value;
    }
  }
}

function setCotizacionAlto(event) {
  if (parseInt(this.value) <= parseInt(this.attributes.max.value) && parseInt(this.value) >= parseInt(this.attributes.min.value)) {
    setAlto(`${this.value} cm`);
    setFormCotizadoAlto(this.value);
    setForm();
  } else {
    if (parseInt(this.value) > parseInt(this.attributes.max.value)) {
      this.value = this.attributes.max.value;
    } else if (parseInt(this.value) < parseInt(this.attributes.min.value)) {
      this.value = this.attributes.min.value;
    }
  }
}

function setCotizacionTelaTipo(event) {
  if (this.dataset.optionScreen === "true" || document.querySelector(".cotiza51").dataset.cotizador == "tradicional") {
    document.querySelector(".cotiza-tela-suboption").firstElementChild.innerHTML = `Selecciona ${this.value}`;
    document.querySelector(".cotiza-tela-suboption").classList.add("show");
    document.querySelector(".cotiza-tela-suboption").classList.remove("no-screen");
  } else {
    document.querySelector(".cotiza-tela-suboption").classList.remove("show");
    document.querySelector(".cotiza-tela-suboption").firstElementChild.innerHTML = `Selecciona Color`;
    document.querySelector(".cotiza-tela-suboption").classList.add("no-screen");
    if (this.dataset.value == "duo") {
      document.querySelector(".cotiza-tela-suboption").classList.add("no-duo");
    } else {
      document.querySelector(".cotiza-tela-suboption").classList.remove("no-duo");
    }
  }
  setTelaColors({"tipo": getCurrentTipo(), "tela": getCurrentTela()});
  setTelaTipo(this.value);
  setFormCotizadoTelaTipo(this);
  setForm();
  setTelaHeight();
}

// Elemento para obtener el tipo de cortina seleccionada
function getCurrentTipo() {
  return (document.querySelector("input[name='cortina-tipos']:checked") ? document.querySelector("input[name='cortina-tipos']:checked").dataset.value : null);
}

// Elemento para obtener el tipo de tela seleccionada
function getCurrentTela() {
  return (document.querySelector("input[name='tela-tipos']:checked") ? document.querySelector("input[name='tela-tipos']:checked").dataset.value : null);
}

// Elemento para obtener el tipo de tela seleccionada
function getCurrentTelaValue() {
  return (document.querySelector("input[name='tela-tipos']:checked") ? document.querySelector("input[name='tela-tipos']:checked").value : null);
}

// Elemento para obtener el tipo de subtela seleccionada en caso de ser una tela screen
function getCurrentSubtela() {
  return (document.querySelector("input[name='tela-suboptions']:checked") ? document.querySelector("input[name='tela-suboptions']:checked").dataset.value : null);
}

// Elemento para obtener la primera tela visible de la lista
function getCurrentRadioWrap() {
  return document.querySelector(".radios .show");
}

// Elemento para obtener el primer color de accesorio visible de la lista
function getCurrentColorAccesorio() {
  return document.querySelector(".radios .show");
}

// Elemento para Instalación
function getCurrentColorAccesorio() {
  return (document.querySelector("input[name='instalacion-tipos']:checked") ? document.querySelector("input[name='instalacion-tipos']:checked").value : null);
}

function setTelaColors(params) {
  let tela_tipo   = params.tipo;
  let tela_option = params.tela;
  turnOffAllColors();
  document.querySelectorAll("input[name='tela-opcion-colores']").forEach(input_tela_opcion_color => {
    let input_tela = null;
    if (tela_tipo === "roller") {
      if (tela_option === "screen") {
        let active_suboptions = document.querySelectorAll(".suboptions .tela-suboptions");
        active_suboptions.forEach(active_suboption => {
          input_tela = document.querySelectorAll(`.tradicional-products .product-tela-tradicional-tradicional[data-product-tipo='${input_tela_opcion_color.parentElement.parentElement.firstElementChild.firstElementChild.firstElementChild.dataset.value}'][data-product-color='${input_tela_opcion_color.dataset.value}']`);
          turnOnActiveColors({"input": input_tela, "input_tela_opcion_color": input_tela_opcion_color});
        });
      } else {
        input_tela = document.querySelectorAll(`.normal-products .product-tela-roller[data-product-tela='${tela_option}'][data-product-color='${input_tela_opcion_color.dataset.value}']`);
        turnOnActiveColors({"input": input_tela, "input_tela_opcion_color": input_tela_opcion_color});
      }
    } else {
      if (tela_option === "screen") {
        let active_suboptions = document.querySelectorAll(".suboptions .tela-suboptions");
        active_suboptions.forEach(active_suboption => {
          input_tela = document.querySelectorAll(`.duo-products .product-tela-roller-duo[data-product-tela='${tela_option}'][data-product-tipo='${active_suboption.dataset.value}'][data-product-color='${input_tela_opcion_color.dataset.value}']`)
          turnOnActiveColors({"input": input_tela, "input_tela_opcion_color": input_tela_opcion_color});
        });
      } else {
        input_tela = document.querySelectorAll(`.duo-products .product-tela-roller-duo[data-product-tela='${tela_option}'][data-product-color='${input_tela_opcion_color.dataset.value}']`);
        turnOnActiveColors({"input": input_tela, "input_tela_opcion_color": input_tela_opcion_color});
      }
    }
    if (tela_tipo === "tradicional") {
      const suboption = input_tela_opcion_color.closest(".suboptions");
      const productTipo = suboption ? suboption.dataset.productTipo : "";
      input_tela = findTradicionalTelaProductsFromStore({
        productTipo,
        productColor: input_tela_opcion_color.dataset.value
      });
      if (input_tela.length === 0) {
        input_tela = document.querySelectorAll(`.tradicional-products .product-tela-tradicional-tradicional[data-product-tipo='${productTipo}'][data-product-color='${input_tela_opcion_color.dataset.value}']`);
      }
      turnOnActiveColors({"input": input_tela, "input_tela_opcion_color": input_tela_opcion_color});
    }
  });
  let eClick = new Event('click');
  let eChange = new Event('change');
  let radio_wrap = document.querySelectorAll(".option2 .suboptions:not(.hide) .radio-wrap");
  if (radio_wrap.length === 0) {
    radio_wrap = document.querySelectorAll(".option2 .suboptions .radio-wrap");
  }
  if (radio_wrap.length > 0) {
    radio_wrap[0].firstElementChild.checked = true;
    radio_wrap[0].firstElementChild.dispatchEvent(eClick);
    radio_wrap[0].firstElementChild.dispatchEvent(eChange);
  }
}

function turnOffAllColors() {
  document.querySelectorAll("input[name='tela-opcion-colores']").forEach(input_tela_opcion_color => {
    input_tela_opcion_color.classList.add("hide");
    input_tela_opcion_color.nextElementSibling.classList.add("hide");
  });
}

function turnOnActiveColors(params) {
  let input_tela              = params["input"];
  let input_tela_opcion_color = params["input_tela_opcion_color"];
  if (input_tela.length > 0) {
    input_tela_opcion_color.classList.remove("hide");
    input_tela_opcion_color.nextElementSibling.classList.remove("hide");
  }
}

function toggleColor(params) {
  let input_tela              = params["input"];
  let input_tela_opcion_color = params["input_tela_opcion_color"];
  if (input_tela.length == 0) {
    input_tela_opcion_color.classList.add("hide");
    input_tela_opcion_color.nextElementSibling.classList.add("hide");
  } else {
    input_tela_opcion_color.classList.remove("hide");
    input_tela_opcion_color.nextElementSibling.classList.remove("hide");
  }
}

function setTelaHeight() {
  document.querySelector(`.tela`).style.maxHeight = document.querySelector(`.tela`).scrollHeight + 'px';
  document.querySelector(`.cotiza-tela-tipo .content`).style.maxHeight = document.querySelector(`.cotiza-tela-tipo .content`).scrollHeight + 'px';
}

function setCotizacionTelaSuboption(event) {
  let tipo_tela = getCurrentTelaValue();
  setTelaTipo(tipo_tela);
  setFormCotizadoTelaSuboption(this);
  setForm();
}

function setCotizacionTelaOptionColor(event) {
  setTelaOptionColor(`${this.value}`);
  setFormCotizadoTelaOpcionColor(this);
  setSkuSoftland()
  setForm();
}

function setCotizacionTipoCortina(event) {
  setTipoCortina(`${this.value}`);
  setFormCotizadoTipoCortina(this);
  setForm();
}

function setCotizacionCantidadPano(event) {
  setCantidadPano(`${this.value}`);
  setFormCotizadoCantidadPano(this);
  setForm();
}

function setCotizacionAccionamientoTipo(event) {
  setAccionamientoTipo(`${this.value}`);
  setFormCotizadoAccionamientoTipo(this);
  setForm();
}

function setCotizacionCaidaSentido(event) {
  setCaidaSentido(`${this.value}`);
  setFormCotizadoCaidaSentido(this);
  setForm();
}

function setCotizacionColorAccesorio(event) {
  setColorAccesorio(`${this.value}`);
  setFormCotizadoColorAccesorio(this);
  setForm();
}

function setCotizacionPosicionMando(event) {
  setPosicionMando(`${this.value}`);
  setFormCotizadoPosicionMando(this);
  setForm();
}

function setCotizacionInstalacionCortina(event) {
  setInstalacionCortina(`${this.value}`);
  setFormCotizadoInstalacionCortina(this);
  setForm();
}

function setCotizacionInstalacionTipo(event) {
  setInstalacionTipo(`${this.value}`);
  setFormCotizadoInstalacionTipo(this);
  setForm();
}

function setCotizacionSucursal(event) {
  setForm();
}

function setCotizacionInstalacionRegion(event) {
  setFormCotizadoInstalacionRegion(this.value);
}

function setCotizacionInstalacionComuna(event) {
  setFormCotizadoInstalacionComuna(this.value);
}

function setCotizacionInstalacionDireccion(event) {
  setFormCotizadoInstalacionDireccion(this.value);
}

function setCotizacionNombre(event) {
  setFormCotizadoNombre(this.value);
}

function setCotizacionMensaje(event) {
  setFormCotizadoMensaje(this.value);
}

// Formulario Cotizado
function setFormCotizadoCortinaTipo(input) {
  form_cotizado_cortina_tipo.value         = input.dataset.value;
  form_cotizado_cortina_tipo.dataset.value = input.value;
  input_cortina_tipos.forEach(input_cortina_tipo => {
    input_cortina_tipo.parentNode.parentNode.classList.remove("active");
  });
  input.parentNode.parentNode.classList.add("active");
}

function setFormCotizadoAncho(value) {
  form_cotizado_ancho.value = value;
}

function setFormCotizadoAlto(value) {
  form_cotizado_alto.value = value;
}

function setFormCotizadoTelaTipo(input) {
  form_cotizado_tela_tipo.value         = input.dataset.value;
  form_cotizado_tela_tipo.dataset.value = input.value;
}

function setFormCotizadoTelaSuboption(input) {
  form_cotizado_tela_suboption.value         = input.dataset.value;
  form_cotizado_tela_suboption.dataset.value = input.value;
}

function setFormCotizadoTelaOpcionColor(input) {
  form_cotizado_tela_opcion_color.value         = input.dataset.value;
  form_cotizado_tela_opcion_color.dataset.value = input.value;
}

function setFormCotizadoAccionamientoTipo(input) {
  form_cotizado_accionamiento_tipo.value         = input.dataset.value;
  form_cotizado_accionamiento_tipo.dataset.value = input.value;
}

function setFormCotizadoCaidaSentido(input) {
  form_cotizado_caida_sentido.value         = input.dataset.value;
  form_cotizado_caida_sentido.dataset.value = input.value;
}

function setFormCotizadoCantidadPano(input) {
  form_cotizado_cantidad_pano.value         = input.dataset.value;
  form_cotizado_cantidad_pano.dataset.value = input.value;
}

function setFormCotizadoTipoCortina(input) {
  form_cotizado_tipo_cortina.value         = input.dataset.value;
  form_cotizado_tipo_cortina.dataset.value = input.value;
}

function setFormCotizadoColorAccesorio(input) {
  form_cotizado_color_accesorio.value         = input.dataset.value;
  form_cotizado_color_accesorio.dataset.value = input.value;
}

function setFormCotizadoPosicionMando(input) {
  form_cotizado_mando_posicion.value         = input.dataset.value;
  form_cotizado_mando_posicion.dataset.value = input.value;
}

function setFormCotizadoInstalacionCortina(input) {
  form_cotizado_cortina_instalacion.value         = input.dataset.value;
  form_cotizado_cortina_instalacion.dataset.value = input.value;
}

function setFormCotizadoInstalacionTipo(input) {
  form_cotizado_instalacion.value         = input.dataset.value;
  form_cotizado_instalacion.dataset.value = input.value;
}

function setFormCotizadoInstalacionRegion(value) {
  form_cotizado_instalacion_region.value = input_instalacion_region.options[input_instalacion_region.selectedIndex].text;
}

function setFormCotizadoInstalacionComuna(value) {
  form_cotizado_instalacion_comuna.value = input_instalacion_comuna.options[input_instalacion_comuna.selectedIndex].text;
}

function setFormCotizadoInstalacionDireccion(value) {
  form_cotizado_instalacion_direccion.value = value;
}

function setFormCotizadoNombre(value) {
  form_cotizado_nombre.value = value;
}

function setFormCotizadoMensaje(value) {
  form_cotizado_mensaje.value = value;
}

// Hidden Form Productos
function setHiddenFormProductoSujetadorCadena(params) {
  let input = params["input"];
  let value = params["value"];

  hidden_form_producto_sujetador_cadena.value                    = input.value;
  hidden_form_producto_sujetador_cadena.dataset.productAvailable = input.dataset.productAvailable;
  hidden_form_producto_sujetador_cadena.dataset.productQuantity  = input.dataset.productQuantity;
  hidden_form_producto_sujetador_cadena.dataset.productSku       = input.dataset.productSku;
  hidden_form_producto_sujetador_cadena.dataset.productWeight    = input.dataset.productWeight;
}

function setHiddenFormProductoUnidadControl(params) {
  let input = params["input"];
  let value = params["value"];
  hidden_form_producto_unidad_control.value                    = input.value;
  hidden_form_producto_unidad_control.dataset.productAvailable = input.dataset.productAvailable;
  hidden_form_producto_unidad_control.dataset.productQuantity  = input.dataset.productQuantity;
  hidden_form_producto_unidad_control.dataset.productSku       = input.dataset.productSku;
  hidden_form_producto_unidad_control.dataset.productWeight    = input.dataset.productWeight;
}

function setHiddenFormProductoCadena(params) {
  let input = params["input"];
  let value = params["value"];
  hidden_form_producto_cadena.value                    = value;
  hidden_form_producto_cadena.dataset.productAvailable = input.dataset.productAvailable;
  hidden_form_producto_cadena.dataset.productQuantity  = input.dataset.productQuantity;
  hidden_form_producto_cadena.dataset.productSku       = input.dataset.productSku;
  hidden_form_producto_cadena.dataset.productWeight    = input.dataset.productWeight;
}

function setHiddenFormProductoCierreCadena(params) {
  let input = params["input"];
  let value = params["value"];
  hidden_form_producto_cierre_cadena.value                    = input.value;
  hidden_form_producto_cierre_cadena.dataset.productAvailable = input.dataset.productAvailable;
  hidden_form_producto_cierre_cadena.dataset.productQuantity  = input.dataset.productQuantity;
  hidden_form_producto_cierre_cadena.dataset.productSku       = input.dataset.productSku;
  hidden_form_producto_cierre_cadena.dataset.productWeight    = input.dataset.productWeight;
}

function setHiddenFormProductoClipTope(params) {
  let input = params["input"];
  let value = params["value"];
  hidden_form_producto_clip_tope.value                    = input.value;
  hidden_form_producto_clip_tope.dataset.productAvailable = input.dataset.productAvailable;
  hidden_form_producto_clip_tope.dataset.productQuantity  = input.dataset.productQuantity;
  hidden_form_producto_clip_tope.dataset.productSku       = input.dataset.productSku;
  hidden_form_producto_clip_tope.dataset.productWeight    = input.dataset.productWeight;
}

function setHiddenFormProductoTerminalRielInferior(params) {
  let input = params["input"];
  let value = params["value"];
  hidden_form_producto_terminal_riel_inferior.value                    = input.value;
  hidden_form_producto_terminal_riel_inferior.dataset.productAvailable = input.dataset.productAvailable;
  hidden_form_producto_terminal_riel_inferior.dataset.productQuantity  = input.dataset.productQuantity;
  hidden_form_producto_terminal_riel_inferior.dataset.productSku       = input.dataset.productSku;
  hidden_form_producto_terminal_riel_inferior.dataset.productWeight    = input.dataset.productWeight;
}

function setHiddenFormProductoRielInferior(params) {
  let input = params["input"];
  let value = params["value"];
  hidden_form_producto_riel_inferior.value                    = value;
  hidden_form_producto_riel_inferior.dataset.productAvailable = input.dataset.productAvailable;
  hidden_form_producto_riel_inferior.dataset.productQuantity  = input.dataset.productQuantity;
  hidden_form_producto_riel_inferior.dataset.productSku       = input.dataset.productSku;
  hidden_form_producto_riel_inferior.dataset.productWeight    = input.dataset.productWeight;
}

function setHiddenFormProductoTubo(params) {
  let input = params["input"];
  let value = params["value"];
  hidden_form_producto_tubo.value                    = value;
  hidden_form_producto_tubo.dataset.productAvailable = input.dataset.productAvailable;
  hidden_form_producto_tubo.dataset.productQuantity  = input.dataset.productQuantity;
  hidden_form_producto_tubo.dataset.productSku       = input.dataset.productSku;
  hidden_form_producto_tubo.dataset.productWeight    = input.dataset.productWeight;
}

function setHiddenFormProductoMotor(params) {
  let input = params["input"];
  hidden_form_producto_motor.value                    = input.value;
  hidden_form_producto_motor.dataset.productAvailable = input.dataset.productAvailable;
  hidden_form_producto_motor.dataset.productQuantity  = input.dataset.productQuantity;
  hidden_form_producto_motor.dataset.productSku       = input.dataset.productSku;
  hidden_form_producto_motor.dataset.productWeight    = input.dataset.productWeight;
}

function setHiddenFormProductoTelaRoller(params) {
  let input = params["input"];
  let value = params["value"];
  hidden_form_producto_tela_roller.value                    = value;
  hidden_form_producto_tela_roller.dataset.productAvailable = input.dataset.productAvailable;
  hidden_form_producto_tela_roller.dataset.productQuantity  = input.dataset.productQuantity;
  hidden_form_producto_tela_roller.dataset.productSku       = input.dataset.productSku;
  hidden_form_producto_tela_roller.dataset.productWeight    = input.dataset.productWeight;
}

function setHiddenFormProductoPesoEnvio(params) {
  let value = params["value"];
  let grams = params["grams"];
  hidden_form_producto_peso_envio.value = value;
  hidden_form_producto_peso_envio.dataset.grams = grams;
}

function setHiddenFormProductoZuncho(params) {
  let value = params["value"];
  hidden_form_producto_zuncho.value = value;
}

function setHiddenFormProductoConfeccion(params) {
  let value = params["value"];
  hidden_form_producto_confeccion.value = value;
}

function setHiddenFormProductoInstalacion(params) {
  let value = params["value"];
  hidden_form_producto_instalacion.value = value;
}

// Hidden Form Productos Tradicional
function copyHiddenProductMetadata(targetElement, input) {
  if (!targetElement || !input || !input.dataset) return;

  if ('productAvailable' in input.dataset) {
    targetElement.dataset.productAvailable = input.dataset.productAvailable;
  }

  if ('productQuantity' in input.dataset) {
    targetElement.dataset.productQuantity = input.dataset.productQuantity;
  }

  if ('productSku' in input.dataset) {
    targetElement.dataset.productSku = input.dataset.productSku;
  }

  if ('productTitle' in input.dataset) {
    targetElement.dataset.productTitle = input.dataset.productTitle;
  }

  if ('descripcionSoftland' in input.dataset) {
    targetElement.dataset.descripcionSoftland = input.dataset.descripcionSoftland;
  }

  if ('skuSoftland' in input.dataset) {
    targetElement.dataset.skuSoftland = input.dataset.skuSoftland;
  }

  if ('productWeight' in input.dataset) {
    targetElement.dataset.productWeight = input.dataset.productWeight;
  }

  if ('productWeightUnit' in input.dataset) {
    targetElement.dataset.productWeightUnit = input.dataset.productWeightUnit;
  }
}

function setHiddenFormProductoTelaTradicional(params) {
  let input = params["input"];
  let value = params["value"];
  hidden_form_producto_tela_trd.value = value;
  copyHiddenProductMetadata(hidden_form_producto_tela_trd, input);
}

function setHiddenFormProductoPesoEnvioTradicional(params) {
  let value = params["value"];
  let grams = params["grams"];
  hidden_form_producto_peso_envio_trd.value = value;
  hidden_form_producto_peso_envio_trd.dataset.grams = grams;
}

function setHiddenFormProductoConfeccionTradicional(params) {
  let input = params["input"];
  let value = params["value"];
  hidden_form_producto_confeccion_trd.value = value;
  copyHiddenProductMetadata(hidden_form_producto_confeccion_trd, input);
}

function setHiddenFormProductoInputConfeccionTradicional(params) {
  let value = params["value"];
  hidden_producto_confeccion_trd.value = value;
}

function setHiddenFormProductoInstalacionTradicional(params) {
  let input = params["input"];
  let value = params["value"];
  hidden_form_producto_instalacion_trd.value = value;
  copyHiddenProductMetadata(hidden_form_producto_instalacion_trd, input);
}

// hidden Products Tradicional
function getHiddenProductoTelaTradicional() {
  let sku = "";
  let skuValue = "";
  if (document.querySelector("input[name='tela-opcion-colores']:checked") !== null) {
    skuValue = document.querySelector("input[name='tela-opcion-colores']:checked").dataset.sku;
    sku = `[data-product-sku='${skuValue}']`;
  }

  const storeFilters = {
    productColor: form_cotizado_tela_opcion_color.value
  };

  if (skuValue) {
    storeFilters.productSku = skuValue;
  }

  const storeProduct = findTradicionalTelaProductsFromStore(storeFilters)[0];
  if (storeProduct) {
    return storeProduct;
  }

  let current_checked = document.querySelector(`.tradicional-products .product-tela-tradicional-tradicional${sku}[data-product-color='${form_cotizado_tela_opcion_color.value}']`);
  return current_checked;
}

function getDescripcionSoftlandFromSelectionTradicional() {
  const selectedProduct = getHiddenProductoTelaTradicional();
  if (selectedProduct && selectedProduct.dataset) {
    return (selectedProduct.dataset.descripcionSoftland || "").trim();
  }
  return "";
}

function calculaCotizacion() {
  let total                   = getTotal();
  let total_precio            = total.toString().replace(MONEY_REGEX, ".");
  total_precio_input.value    = total
  total_precio_html.innerHTML = `$${total_precio}`;
}

function getTotal() {
  let total        = 0;

  // Productos Tradicionales
  let tela_tradicional        = hidden_form_producto_tela_trd.value;
  let confeccion_tradicional  = hidden_form_producto_confeccion_trd.value;
  total                       = Math.round(parseInt(tela_tradicional) + parseInt(confeccion_tradicional));

  return total;
}

function getFormQuote() {
  // Cotizador Tradicional
  let quoteText    = "";

  quoteText = `<h3 class="inner-title">Resumen Productos </h3>
    <div class="line line-sku"><span class="var var-title">Tela tradicional:</span><span class="val val-sku"> ${hidden_form_producto_tela_trd.dataset.productSku}</span></div>`;
  if (hidden_form_producto_instalacion.value !== "0" && hidden_form_producto_instalacion.value !== "") {
    quoteText += `<div class="line line-sku"><span class="var var-title">Instalación Región:</span><span class="val val-sku"> ${form_cotizado_instalacion_region.value}</span></div>
      <div class="line line-sku"><span class="var var-title">Instalación Comuna:</span><span class="val val-sku"> ${form_cotizado_instalacion_comuna.value}</span></div>
      <div class="line line-sku"><span class="var var-title">Instalación Dirección:</span><span class="val val-sku"> ${form_cotizado_instalacion_direccion.value}</span></div>`;
  }
  quoteText += `<div class="line line-sku"><span class="var var-title">Nombre:</span><span class="val val-sku"> ${form_cotizado_nombre.value}</span></div>
    <div class="line line-sku last"><span class="var var-title">Mensaje:</span><span class="val val-instalacion-cortina"> ${form_cotizado_mensaje.value}</span></div>`;

  return quoteText;
}

function setImagePreview({ input }) {
  if (input) {
    const { productImage, productImageZoom, productImageExtra, productImageExtraZoom } = input.dataset;

    // Actualizar imagen principal
    preview_image.src = productImage;
    preview_image.srcset = productImage;
    preview_image.parentElement.href = productImageZoom;

    // Actualizar imagen extra
    preview_image_zoom.src = productImageExtra;
    preview_image_zoom.srcset = productImageExtra;
    preview_image_zoom.parentElement.href = productImageExtraZoom;

    $('.easyzoom').each(function() {
      const easyzoomInstance = $(this).data('easyZoom');
      easyzoomInstance.teardown();
      $(this).easyZoom({
        loadingNotice: 'Cargando imagen'
      });
    });
  }
}

function calculateTelaRoller(params) {
  // (((C22/100)+(20/100))*1,25*H13)
  let input = params["input"];
  if (input !== null) {
    setImagePreview({"input": input});
    total = Math.round(parseFloat(((parseFloat(form_cotizado_alto.value)/100) + (20/100)) * 1.25 * parseFloat(input.value)));
    setHiddenFormProductoTelaRoller({"input": input, "value": total});
  }
}

function calculateTotalWeight(params) {
  let sujetador      = params["sujetador"];
  let unidad_control = params["unidad_control"];
  let cierre_cadena  = params["cierre_cadena"];
  let clip_tope      = params["clip_tope"];
  let motor          = params["motor"];
  let terminal       = params["terminal"];
  let cadena         = params["cadena"];
  let riel           = params["riel"];
  let tubo           = params["tubo"];
  let zuncho         = params["zuncho"];
  let tela           = params["tela"];
  let peso           = 0;
  if (sujetador !== null && unidad_control !== null && cierre_cadena !== null && clip_tope !== null && motor !== null && terminal !== null && cadena !== null && riel !== null && tubo !== null && zuncho !== null && tela !== null) {
    peso = (parseInt(sujetador.dataset.productWeight) + parseInt(unidad_control.dataset.productWeight) + parseInt(cierre_cadena.dataset.productWeight) + parseInt(clip_tope.dataset.productWeight) + parseInt(motor.dataset.productWeight) + parseInt(terminal.dataset.productWeight) + parseInt(cadena.dataset.productWeight) + parseInt(riel.dataset.productWeight) + parseInt(tubo.dataset.productWeight) + parseInt(zuncho.dataset.productWeight) + (parseInt(tela.dataset.productWeight) * Math.ceil(input_ancho.value / 100))) / 1000;
    setHiddenFormProductoPesoEnvio({"value": peso, "grams": peso * 1000});
  }
}

// Calculate Tradicional
function calculateTelaTradicional(params) {
  // (((C22/100)+(20/100))*1,25*H13)
  let input        = params["input"];
  let tipo_cortina = document.querySelector("input[name='tipo-cortinas']:checked").dataset.value;
  let multiplier   = 1;
  if (tipo_cortina === "tres-pliegues") {
    multiplier = 3;
  } else if (tipo_cortina === "presilla" || tipo_cortina === "dos-pliegues" || tipo_cortina === "ojetillos") {
    multiplier = 2;
  } else if (tipo_cortina === "presillas-pliegue") {
    multiplier = 2.5;
  }
  if (input !== null) {
    setImagePreview({"input": input});
    total = Math.round(parseFloat((parseFloat(form_cotizado_ancho.value)/100) * (parseFloat(input.value) * multiplier)));
    setHiddenFormProductoTelaTradicional({"input": input, "value": total});
  }
}

function calculateTotalWeightTradicional(params) {
  let tela = params["tela"];
  let peso = 0;
  if (tela !== null) {
    peso = ((parseInt(tela.dataset.productWeight) * Math.ceil(input_ancho.value / 100))) / 1000;
    setHiddenFormProductoPesoEnvioTradicional({"value": peso, "grams": peso * 1000});
  }
}

function calculateConfeccionTradicional(params) {
  // (ValorConfeccion*(AnchoCortina*FactorTipoCortina)/1000)
  // (K13*(B23*C22)/10000)
  let input = params["input"];
  let multiplier = getMultiplier();
  total = Math.round(parseFloat(parseFloat(input.value) * (parseFloat(form_cotizado_ancho.value) * parseFloat(multiplier) / 100)));
  setHiddenFormProductoConfeccionTradicional({"input": input, "value": total});
}

// Submit Cotizador
async function submitCotizacion() {
  if (validateForm()) {
    try {
    closeAllTitles();
    let formQuote    = getFormQuote();
    let disclaimer   = document.querySelector(".quote-disclaimer").innerHTML;
    let tela_title   = form_cotizado_tela_tipo.dataset.value;
    let peso         = parseInt(hidden_form_producto_peso_envio.value);
    let peso_gramos  = parseInt(hidden_form_producto_peso_envio.dataset.grams);
    let tipo_cortina = document.querySelector("input[name='cortina-tipos']:checked").dataset.value;
    if (form_cotizado_tela_tipo.value === "screen") {
      tela_title = `${form_cotizado_tela_tipo.dataset.value} - ${form_cotizado_tela_suboption.dataset.value}`;
    }
    if (form_cotizado_cortina_tipo.value === "duo") {
      peso        = parseInt(hidden_form_producto_peso_envio_duo.value);
      peso_gramos = parseInt(hidden_form_producto_peso_envio_duo.dataset.grams);
    }
    const descripcionSoftland = getDescripcionSoftlandFromSelectionTradicional();
    let body_html = `
      <div class="resumen">
        <h3 class="inner-title">Resumen Cotización:<span class="val-cortina-tipo"> ${form_cotizado_cortina_tipo.dataset.value} - ${form_cotizado_nombre.value}</span></h3>
        <div class="line line-product"><span class="var">Ancho:</span><span class="val val-ancho"> ${form_cotizado_ancho.value} cm</span></div>
        <div class="line line-product"><span class="var">Alto:</span><span class="val val-alto"> ${form_cotizado_alto.value} cm</span></div>
        <div class="line line-product"><span class="var">Tela:</span><span class="val val-tela-tipo"> ${tela_title}</span></div>
        <div class="line line-product"><span class="var">Color Tela:</span><span class="val val-tela-suboption"> ${form_cotizado_tela_opcion_color.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Descripción Softland:</span><span class="val val-descripcion-softland"> ${descripcionSoftland}</span></div>`;
    if (tipo_cortina === "roller" || tipo_cortina === "roller-duo") {
      body_html = body_html + `
        <div class="line line-product"><span class="var">Tipo de accionamiento:</span><span class="val val-accionamiento-tipo"> ${form_cotizado_accionamiento_tipo.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Sentido de caída de la tela:</span><span class="val val-caida-sentido"> ${form_cotizado_caida_sentido.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Color del accesorio:</span><span class="val val-color-accesorio"> ${form_cotizado_color_accesorio.dataset.value}</span></div>`;
    } else {
      body_html = body_html + `
        <div class="line line-product"><span class="var">Tipo cortina:</span><span class="val val-tipo-cortina"> ${form_cotizado_tipo_cortina.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Cantidad paños:</span><span class="val val-cantidad-pano"> ${form_cotizado_cantidad_pano.dataset.value}</span></div>`;
    }
    if (tipo_cortina === "roller" || tipo_cortina === "roller-duo") {
      body_html = body_html + `
        <div class="line line-product"><span class="var">Posición del mando:</span><span class="val val-posicion-mando"> ${form_cotizado_mando_posicion.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Instalación de cortina:</span><span class="val val-instalacion-cortina"> ${form_cotizado_cortina_instalacion.dataset.value}</span></div>
        <div class="line line-product"><span class="var">Instalación a domicilio:</span><span class="val val-instalacion"> ${form_cotizado_instalacion.dataset.value}</span></div>
        <div class="line line-product last"><span class="var">Cantidad:</span><span class="val val-quantity"> xxxxx</span></div>`;
    }
    body_html = body_html + `
        <div class="bottom">
          <h6 class="precio precio-total">Total: <span>${total_precio_html.innerHTML}</span></h6>
          <p class="red">${disclaimer}</p>
        </div>
        <div class="resumen-p">
          ${formQuote}
        </div>
      </div>`;
    const storeCode = (typeof getCotizadorStoreCode === "function" && getCotizadorStoreCode()) || (window.Shopify.shop || "").split(".")[0];
    const customerEmail = (typeof getCotizadorStoreEmailFallback === "function" && getCotizadorStoreEmailFallback()) || `cotizador@${window.Shopify.shop}`;
    const totalPrice = Number(total_precio_input.value || 0);

    const quotePayload = {
      store: storeCode,
      customerName: form_cotizado_nombre.value || "Cliente Cotizador",
      customerEmail,
      currency: "CLP",
      priceList: "LA",
      notes: form_cotizado_mensaje.value || null,
      items: (typeof buildQuoteItemsFromHiddenProducts === "function" ? buildQuoteItemsFromHiddenProducts(document) : [])
    };

    const tempProductPayload = {
      store: storeCode,
      title: `Cotización - ${form_cotizado_nombre.value}`,
      price: totalPrice,
      currency: "CLP",
      sku: form_cotizado_homologado_venta.value || "COTIZA-B2C",
      quantity: 1,
      descriptionHtml: body_html
    };

    await processCotizadorQuoteTempProductCart({
      quotePayload,
      tempProductPayload,
      quantity: 1
    }, { container: cotiza_container });
    hidden_cotizacion_area.innerHTML = hidden_cotizacion_area.innerHTML + body_html + "<br><br>";
    document.querySelector(".btn.print").classList.add("show");
    document.querySelector(".btn.email").classList.add("show");
    } catch (error) {
      const quoteContext = (error && error.message) ? error.message : "sin contexto";
      console.error("Error en flujo v3 cotizador (quote/temp-product/cart)", quoteContext, error);
      if (typeof showCotizadorFunctionalError === "function") {
        showCotizadorFunctionalError("No se pudo procesar la cotización en este momento.");
      }
    }
  } else {
    return;
  }
}

async function syncThemeCartUIFeedback() {
  try {
    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
      method: "GET",
      credentials: "include"
    });
    const cartState = await cartResponse.json();

    if (typeof window.emit === "function") {
      window.emit("quick-cart:updated");
      window.emit("cart:updated", { cart: cartState });
    }

    document.dispatchEvent(new CustomEvent("quick-cart:updated"));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cartState } }));
  } catch (error) {
    console.error("No se pudo sincronizar feedback UI del carrito", error);
  }
}

function validateForm() {
  let return_flag = true;
  let tipo_cotizador = document.querySelector(".cotiza51").dataset.cotizador;
  if (return_flag && form_cotizado_cortina_tipo.value.length == 0) {
    input_cortina_tipos[0].focus();
    return_flag = false;
  }
  if (return_flag && (form_cotizado_ancho.value.length == 0 || parseInt(form_cotizado_alto.value) < input_ancho.min || parseInt(form_cotizado_alto.value) > input_ancho.max)) {
    openTitle(document.querySelector(".title-select-h1[data-option-number='1']"));
    input_ancho.focus();
    return_flag = false;
  }
  if (return_flag &&  (form_cotizado_alto.value.length == 0 || parseInt(form_cotizado_alto.value) < input_alto.min || parseInt(form_cotizado_alto.value) > input_alto.max)) {
    closeAllTitles();
    openTitle(document.querySelector(".title-select-h1[data-option-number='1']"));
    input_ancho.focus();
    return_flag = false;
  }
  if (return_flag && form_cotizado_tela_tipo.value.length == 0) {
    closeAllTitles();
    openTitle(document.querySelector(".title-select-h1[data-option-number='2']"));
    input_tela_tipos[0].focus();
    return_flag = false;
  }
  if (return_flag && form_cotizado_tela_suboption.value.length == 0) {
    closeAllTitles();
    openTitle(document.querySelector(".title-select-h1[data-option-number='2']"));
    openSubtitle(document.querySelector(".title-select-h4[data-option-number='1']"));
    input_tela_suboptions[0].focus();
    return_flag = false;
  }
  if (return_flag && form_cotizado_tela_opcion_color.value.length == 0) {
    closeAllTitles();
    openTitle(document.querySelector(".title-select-h1[data-option-number='2']"));
    openSubtitle(document.querySelector(".title-select-h4[data-option-number='1']"));
    const firstTelaColor = document.querySelector("input[name='tela-opcion-colores']");
    if (firstTelaColor) firstTelaColor.focus();
    return_flag = false;
  }
  if (tipo_cotizador == "roller") {
    if (return_flag && form_cotizado_caida_sentido.value.length == 0) {
      closeAllTitles();
      openTitle(document.querySelector(".title-select-h1[data-option-number='4']"));
      input_caida_sentidos[0].focus();
      return_flag = false;
    }
    if (return_flag && form_cotizado_mando_posicion.value.length == 0) {
      closeAllTitles();
      openTitle(document.querySelector(".title-select-h1[data-option-number='5']"));
      input_mando_posiciones[0].focus();
      return_flag = false;
    }
    if (return_flag && form_cotizado_color_accesorio.value.length == 0) {
      closeAllTitles();
      openTitle(document.querySelector(".title-select-h1[data-option-number='7']"));
      input_color_accesorios[0].focus();
      return_flag = false;
    }
    if (return_flag && form_cotizado_cortina_instalacion.value.length == 0) {
      closeAllTitles();
      openTitle(document.querySelector(".title-select-h1[data-option-number='7']"));
      input_cortina_instalaciones[0].focus();
      return_flag = false;
    }
    if (return_flag && (region_select.value === '1' && region_direccion.value.length === 0 && parseInt(form_cotizado_instalacion.value) !== 0)) {
      closeAllTitles();
      openTitle(document.querySelector(".title-select-h1[data-option-number='8']"));
      input_instalacion_direccion.focus();
      return_flag = false;
    }
    if (return_flag && form_cotizado_cortina_instalacion.value.length == 0) {
      closeAllTitles();
      openTitle(document.querySelector(".title-select-h1[data-option-number='7']"));
      input_cortina_instalaciones[0].focus();
      return_flag = false;
    }
  }
  if (return_flag && (form_cotizado_nombre.value.length == 0 || form_cotizado_nombre.value.length > input_nombre.maxLength)) {
    closeAllTitles();
    openTitle(document.querySelector(".title-select-h1[data-option-number='9']"));
    input_nombre.focus();
    return_flag = false;
  }
  if (return_flag && (form_cotizado_mensaje.value.length == 0 || form_cotizado_mensaje.value.length > input_mensaje.maxLength)) {
    closeAllTitles();
    openTitle(document.querySelector(".title-select-h1[data-option-number='9']"));
    input_mensaje.focus();
    return_flag = false;
  }
  return return_flag;
}

function getMultiplier() {
  let tipo_cortina = document.querySelector("input[name='tipo-cortinas']:checked").dataset.value;
  let multiplier   = 1;
  if (tipo_cortina === "tres-pliegues") {
    multiplier = 3;
  } else if (tipo_cortina === "presilla") {
    multiplier = 2;
  } else if (tipo_cortina === "presillas-pliegue") {
    multiplier = 2.5;
  }

  return multiplier;
}

function indexInParent(node) {
  let children = node.parentNode.childNodes;
  let num      = 0;
  for (let i = 0; i < children.length; i++) {
      if (children[i] === node) return num;
      if (children[i].nodeType === 1) num++;
  }
  return -1;
}

function findGetParameter(parameterName) {
  var result = null, tmp = [];
  location.search.substr(1).split("&").forEach(function(item) {
    tmp = item.split("=");
    if (tmp[0] === parameterName) {
      result = decodeURIComponent(tmp[1]);
    }
  });
  return result;
}

/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
function update_mini_cart(show = false, all = true, quote = false) {
  let cotizacion_total = 0;
  jQuery.get("/cart.js", function(data) {
    for (var i = 0; i < data.items.length; i++) {
      if (data.items[i]["product_type"] == "Cotiza Cortina") {
        quote = true;
      }
      if (quote) {
        cotizacion_total += parseFloat(data.items[i]["final_line_price"]);
      }
    }
    var total     = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    if (quote || total == 0) {
      var cotización_total_format = cotizacion_total ? cotizacion_total.toString().substring(0, cotizacion_total.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      $(".inner-cotizacion-total span").html('$' + cotización_total_format);
      if (cotizacion_total == 0) {
        $(".btn.print").removeClass("show");
        $(".inner-cotizacion-content").empty();
      }
    }
  }, 'json');
}

var $easyzoom = $('.easyzoom').easyZoom({
  loadingNotice: 'Cargando imagen'
});
